import { render, staticRenderFns } from "./certificateInspection.vue?vue&type=template&id=78ffda30&scoped=true"
import script from "./certificateInspection.vue?vue&type=script&lang=js"
export * from "./certificateInspection.vue?vue&type=script&lang=js"
import style0 from "./certificateInspection.vue?vue&type=style&index=0&id=78ffda30&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ffda30",
  null
  
)

export default component.exports